export default "__VITE_ASSET__D9xgrSxU__"